angular.module('tgaAdmin').config(['$compileProvider', 'envServiceProvider',
  function ($compileProvider, envServiceProvider) {
    if (envServiceProvider.get() === 'production') {
      $compileProvider.debugInfoEnabled(false);
    } else {
      $compileProvider.debugInfoEnabled(true);
    }
  },
]);
